const apiConstants = {
  ENDPOINTS: {
    BACKEND: {
      BASE:
        process.env.BACKEND_API_URL?.indexOf('http') === 0
          ? process.env.BACKEND_API_URL
          : `https://${process.env.BACKEND_API_URL}`,
      ROUTES: {
        ADMIN_OPEN_ASKS: '/admin/asks/open',
        ADMIN_OPEN_BIDS: '/admin/bids/open',
      },
    },
  },
  RESPONSES: {
    SUCCESS: {
      CODE: 200,
      MESSAGE: 'OK',
    },
    CREATED: {
      CODE: 201,
      MESSAGE: 'Created',
    },
    ACCEPTED: {
      CODE: 202,
      MESSAGE: 'Accepted',
    },
    NO_CONTENT: {
      CODE: 204,
      MESSAGE: 'No Content',
    },
    BAD_REQUEST: {
      CODE: 400,
      MESSAGE: 'Bad Request',
    },
    UNAUTHORIZED: {
      CODE: 401,
      MESSAGE: 'Unauthorized',
    },
    FORBIDDEN: {
      CODE: 403,
      MESSAGE: 'Forbidden',
    },
    NOT_FOUND: {
      CODE: 404,
      MESSAGE: 'Not Found',
    },
    METHOD_NOT_ALLOWED: {
      CODE: 405,
      MESSAGE: 'Method Not Allowed',
    },
    CONFLICT: {
      CODE: 409,
      MESSAGE: 'Conflict',
    },
    UNPROCESSABLE_ENTITY: {
      CODE: 422,
      MESSAGE: 'Unprocessable Entity',
    },
    INTERNAL_SERVER_ERROR: {
      CODE: 500,
      MESSAGE: 'Internal Server Error',
    },
    NOT_IMPLEMENTED: {
      CODE: 501,
      MESSAGE: 'Not Implemented',
    },
    BAD_GATEWAY: {
      CODE: 502,
      MESSAGE: 'Bad Gateway',
    },
    SERVICE_UNAVAILABLE: {
      CODE: 503,
      MESSAGE: 'Service Unavailable',
    },
    GATEWAY_TIMEOUT: {
      CODE: 504,
      MESSAGE: 'Gateway Timeout',
    },
  },
};

export default apiConstants;
